import { Component, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { NDCDevelopmentRoadmapPage } from 'src/app/model/page/ndc-development-roadmap-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-ndc-development-roadmap-page',
  templateUrl: './ndc-development-roadmap-page.component.html',
  styleUrls: ['./ndc-development-roadmap-page.component.scss']
})
export class NDCDevelopmentRoadmapPageComponent implements OnInit {
  ndcDevelopmentRoadmapPage: NDCDevelopmentRoadmapPage = {} as NDCDevelopmentRoadmapPage;
  quarterKeyValueMap = new Map();
  constructor(private contentfulService: ContentfulService) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'NDC 21.3 Development Roadmap') {
        this.ndcDevelopmentRoadmapPage.htmlTitle = title.htmlTitle;
      }
    });
    this.ndcDevelopmentRoadmapPage.sections = [];
    this.ndcDevelopmentRoadmapPage.ndcDevelopmentRoadmapSections = [];

    const query = { 'fields.title': 'NDC 21.3 Development Roadmap' };
    this.contentfulService.getPageContentResponse(query).then((ndcDevelopmentRoadmapPageEntries) => {
      this.mapBanners(ndcDevelopmentRoadmapPageEntries.includes.Entry);
      this.mapPageInfo(ndcDevelopmentRoadmapPageEntries.items);
      this.mapSections(ndcDevelopmentRoadmapPageEntries.includes.Entry);
    });
  }

  private mapBanners(ndcDevelopmentRoadmapPageEntries: Entry<any>[]) {
    ndcDevelopmentRoadmapPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let imageDetails: any = entry.fields['image'];
    this.ndcDevelopmentRoadmapPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: imageDetails.fields.file.url
    };
  }

  private mapPageInfo(items: Entry<any>[]) {
    items.forEach((entry: any) => {
      let editorDetails = entry.fields?.editorDetails?.split('#');
      this.ndcDevelopmentRoadmapPage.banner.lastUpdated = entry.fields?.lastUpdated;
      this.ndcDevelopmentRoadmapPage.banner.url = entry.fields?.url;
      this.ndcDevelopmentRoadmapPage.banner.editorEmail = editorDetails?.pop();
      this.ndcDevelopmentRoadmapPage.banner.editorShortName = editorDetails?.pop();
      this.ndcDevelopmentRoadmapPage.banner.editorFullName = editorDetails?.pop();
      this.ndcDevelopmentRoadmapPage.htmlTitle = entry.fields.htmlTitle;
    });
  }

  private mapSections(ndcDevelopmentRoadmapPageEntries: Entry<any>[]) {
    ndcDevelopmentRoadmapPageEntries
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        switch (entry.fields['position']) {
          case 'MIDDLE':
            this.mapEntryToSection(entry);
            break;
          default:
            this.mapEntryToLeftRightSection(entry);
        }
      });
    this.ndcDevelopmentRoadmapPage.ndcDevelopmentRoadmapSections.sort((a: any, b: any) => b.order - a.order);
  }

  private mapEntryToSection(entry: Entry<any>) {
    let givenTitle: any = entry.fields['title'] as string;
    let pageTitle = givenTitle.split('#').pop();
    this.ndcDevelopmentRoadmapPage.sections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number
    });
  }

  private mapEntryToLeftRightSection(entry: Entry<any>) {
    let title: any = entry.fields['title'] as string;    
    this.ndcDevelopmentRoadmapPage.ndcDevelopmentRoadmapSections.push({
      title: title.split('#').pop(),
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      position: entry.fields['position'] as string,
      category: entry.fields['category'] as string,
      heading: entry.fields['heading'] as string,
      sectionClass: entry.fields['sectionClass'] as string,
      subBody: entry.fields['subBody'] as string,
      roadmapYear: entry.fields['roadmapYear'] as string
    });
  }
}
